const videoBlock = {
  el: {
    blocks: document.querySelectorAll<HTMLElement>('.article-video-block'),
  },

  init(): void {
    this.el.blocks.forEach((block: HTMLElement) => {
      this.toggleVideo(block)

      if (!block.querySelector<HTMLPictureElement>('.article-video-block__picture')) {
        block.classList.add('article-video-block--nocover')
      }
    })
  },

  closeVideo(event, block, video): void {
    const element = event.target as HTMLElement

    if (!element.closest('.article-video-block__video-column') && video) {
      video.pause()
      block.classList.remove('article-video-block--active')

      document.removeEventListener('click', this.onClickOutside)
    }
  },

  onClickOutside: undefined,

  openVideo(block, video): void {
    block.classList.add('article-video-block--active')
    // block.classList.remove('article-video-block--covered')

    if (video) {
      setTimeout(() => {
        video.play()
      }, 567)
    }

    this.onClickOutside = (event) => {
      videoBlock.closeVideo(event, block, video)
    }

    document.addEventListener('click', this.onClickOutside)
  },

  toggleVideo(target): void {
    const buttons = target.querySelectorAll('button')
    const video = target.querySelector('video')

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.openVideo(target, video)
      })
    })
  },
}

export default videoBlock
